import { apiConfig } from "./apiConfig";

export const familyApi = apiConfig.injectEndpoints({
  endpoints: (builder) => ({
    getFamilyList: builder.query<
      any,
      {
        startKey: string;
        page_size?: number | string;
        brand_id: string | null;
      }
    >({
      query: ({ startKey, page_size, brand_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family`,
        params: {
          start_key: startKey,
          page_size: Number(page_size),
        },
      }),
      providesTags: ["Family"],
    }),

    createFamily: builder.mutation<any, { brand_id: string | null; body: any }>(
      {
        query: ({ body, brand_id }) => ({
          url: `/v1/ap/admin/brand/${brand_id}/family`,
          method: "POST",
          body: body,
        }),
        invalidatesTags: ["Family"],
      }
    ),

    getSingleFamilyDetails: builder.query<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
      }
    >({
      query: ({ brand_id, family_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}`,
      }),
      providesTags: ["Family"],
    }),

    editFamily: builder.mutation<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        body: any;
      }
    >({
      query: ({ brand_id, body, family_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["Family"],
    }),
    getTimezoneList: builder.query<any, void>({
      query: () => ({
        url: `/v1/ap/admin/tzformat`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetFamilyListQuery,
  useCreateFamilyMutation,
  useLazyGetSingleFamilyDetailsQuery,
  useEditFamilyMutation,
  useLazyGetTimezoneListQuery,
} = familyApi;
